import {getProducerStoreLink} from '@/lib/link'
import {Producer, ProducerStore} from '@/types'
import {Exporter} from 'react-admin'

// Custom CSV download function
const downloadCustomCSV = (data: any[], filename: string) => {
	const headers = Object.keys(data[0] || {})
	const csvContent = [
		headers.join(','),
		...data.map(row => headers.map(header => {
			const value = row[header]
			// Escape commas and quotes, handle null/undefined
			const stringValue = value == null ? '' : String(value)
			return stringValue.includes(',') || stringValue.includes('"')
				? `"${stringValue.replace(/"/g, '""')}"`
				: stringValue
		}).join(','))
	].join('\n')

	const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8;'})
	const link = document.createElement('a')
	link.href = URL.createObjectURL(blob)
	link.setAttribute('download', filename)
	document.body.appendChild(link)
	link.click()
	document.body.removeChild(link)
}

export const producerExporter: Exporter = async (producers: Producer[], fetchRelatedRecords) => {
	// Fetch des données des relations en utilisant fetchRelatedRecords correctement
	const [communes, activities] = await Promise.all([
		fetchRelatedRecords(producers, 'commune', 'communes'),
		fetchRelatedRecords(producers, 'activity', 'activities')
	])

	const csvData = producers.map((producer) => {
		const commune = communes[producer.commune] as any
		const activity = activities[producer.activity] as any
		const terroir = commune?.terroir as any

		return {
			'ID': producer.id,
			'Nom': producer.name || '',
			'SIREN': producer.siren || '',
			'Email': producer.email || '',
			'Téléphone': producer.phone || '',
			'Site web': producer.website || '',
			'Adresse': producer.address || '',
			'Code postal': commune?.zipcode || producer.commune_zipcode || '',
			'Commune': commune?.name || `ID: ${producer.commune}`,
			'Terroir': terroir?.name || '',
			'Activité': activity?.name || `ID: ${producer.activity}`,
			'Description': producer.description || '',
			'CA': producer.ca ? `${Number(producer.ca).toLocaleString('fr-FR')} €` : '',
			'Capital social': producer.capital_social ? `${Number(producer.capital_social).toLocaleString('fr-FR')} €` : '',
			'Effectifs': producer.effectifs || '',
			'Statut administratif': producer.administrative_status === 'A' ? 'Actif' : producer.administrative_status === 'C' ? 'Cessé' : '',
			'Date de cessation': producer.cessation_date || '',
			'Validé': producer.is_validated ? 'Oui' : 'Non',
			'Publié': producer.is_published ? 'Oui' : 'Non',
			'Compte utilisateur validé': producer.user_is_validated ? 'Oui' : 'Non',
			'Date de création': producer.createdAt || '',
			'Dernière modification': producer.updatedAt || '',
			'Dernière sync SIRENE': producer.sirene_last_update || '',
			'Lien Admin': `http://localhost:8888/#/producers/${producer.id}/show`
		}
	})

	const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-')
	const filename = `producteurs_export_${timestamp}.csv`

	downloadCustomCSV(csvData, filename)
}

export const producerStoreExporter: Exporter = async (stores: ProducerStore[], fetchRelatedRecords) => {
	// Fetch des données des relations en utilisant fetchRelatedRecords correctement
	const [producers, communes, terroirs] = await Promise.all([
		fetchRelatedRecords(stores, 'producer', 'producers'),
		fetchRelatedRecords(stores, 'commune', 'communes'),
		fetchRelatedRecords(stores, 'terroir', 'terroirs')
	])

	const csvData = stores.map((store) => {
		const producer = producers[store.producer as number] as any
		const commune = communes[store.commune] as any
		const terroir = terroirs[store.terroir] as any
		console.log(producer)
		return {
			'ID': store.id,
			'Nom': store.name || '',
			'SIRET': store.siret || '',
			'Entreprise': producer?.name || producer?.name_enterprise || `ID: ${store.producer}`,
			'SIREN Entreprise': producer?.siren || '',
			'Email': store.email || '',
			'Téléphone': store.phone || '',
			'Site web': store.website || '',
			'Adresse': store.address || '',
			'Adresse complémentaire': store.address_secondary || '',
			'Code postal': commune?.zipcode || store.commune_zipcode || '',
			'Commune': commune?.name || `ID: ${store.commune}`,
			'Terroir': terroir?.name || store.terroir_slug || `ID: ${store.terroir}`,
			'Latitude': store.coordinates?.lat || store.lat || '',
			'Longitude': store.coordinates?.lng || store.lng || '',
			'Description': store.description || '',
			'Vente directe': store.is_direct_selling ? 'Oui' : 'Non',
			'Bio': store.is_organic ? 'Oui' : 'Non',
			'VAD': store.is_vad ? 'Oui' : 'Non',
			'Effectifs': store.effectifs || '',
			'Statut administratif': store.administrative_status === 'A' ? 'Actif' : store.administrative_status === 'C' ? 'Cessé' : '',
			'Date de cessation': store.cessation_date || '',
			'Code APE': store.code_ape || '',
			'Validé': store.is_validated ? 'Oui' : 'Non',
			'Publié': store.is_published ? 'Oui' : 'Non',
			'Réseaux sociaux': store.social ? JSON.stringify(store.social) : '',
			'Horaires': store.opening ? JSON.stringify(store.opening) : '',
			'Date de création': store.createdAt || '',
			'Dernière modification': store.updatedAt || '',
			'Dernière sync SIRENE': store.sirene_last_update || '',
			'Lien Admin': `${process.env.REACT_APP_URL}/#/producers/stores/${store.id}/show`,
			'Lien Front': store.slug && store.terroir_slug ? getProducerStoreLink(store) : ''
		}
	})

	const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-')
	const filename = `etablissements_export_${timestamp}.csv`

	downloadCustomCSV(csvData, filename)
}
